export default __webpack_public_path__ + "static/media/teacup.0aeb9a16.svg";